import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../service/seo.service';
import { UrlcanonicaService } from '../../../service/urlcanonica.service';
import { LicitacionService } from '../../../service/licitacion.service'
import { Router } from '@angular/router';

@Component({
  selector: 'app-recuperar-contrasena',
  templateUrl: './recuperar-contrasena.component.html',
  styleUrls: ['./recuperar-contrasena.component.css']
})
export class RecuperarContrasenaComponent implements OnInit {
	RouteText: any;
	tituloseo: any;
	urlcanonicaseo: any;
	imagenseo: any;
	keywordsseo: any;
	descripcionseo: any;
	confirma = false;
	success = false;
	fail = false;
	formsend: any;

	
	constructor(
		private meta: Meta,
		private title: Title,
		private _seoService: SeoService,
		private _urlcanonicaservice: UrlcanonicaService,
		private _licitacionservice: LicitacionService,
		private router: Router) {}
	
	getSEO(page: string) {
		this._seoService.getSEO(page).subscribe((resp: any) => {
			this.tituloseo = resp.titulo;
			this.descripcionseo = resp.descripcion;
			this.urlcanonicaseo = resp.urlcanonica;
			this.imagenseo = resp.image;
	
			this._urlcanonicaservice.createCanonicalLink();
			this.title.setTitle(this.tituloseo)
			this.meta.updateTag({name: 'description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:card',content: 'summary'})
			this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
			this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
			this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
			this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/recuperar-contrasena'})
			this.meta.updateTag({property: 'og:title',content: this.tituloseo})
			this.meta.updateTag({property: 'og:image',content: this.imagenseo})
			this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
		});
	}
	
	ngOnInit(): void {}
	
	
	onSubmit(form: NgForm) {
		this.formsend = form;
		this.confirma = true;
	}
	
	change() {
		const formulario = {
			Correo: this.formsend.value.email
		}

		this._licitacionservice.postRecoverypass(formulario).subscribe(resp => {
				console.log(resp)
				this.formsend.reset();
				this.success = true;
				this.confirma = false;
			},
			e => {
				console.log(e)
				//this.isLoading = false;
			}
		);
	}
	
	cancel() {
		this.confirma = false;
	}
	closeok() {
		this.success = false;
		this.fail = false;
		this.router.navigate(['/licitaciones/login']);
	}
		
}